var exports = {
  "x6": "button__3q6Yi0",
  "hJ": "counter__stQxF6",
  "h_": "description__7adpMz",
  "s7": "filterButtons__5tK8Px",
  "yu": "metadata__ITlBQ-",
  "Nz": "metadataItem__YXBib_",
  "KB": "sharedSpacesTab__N-todu",
  "kX": "benefitSections__JbdYlu",
  "ph": "benefitSection__ik6MU8",
  "XT": "benefitIcon__lK5vwg",
  "AI": "benefitTitle__Abgtsn",
  "m1": "benefitDescription__Z_WtGC",
  "vM": "loadMoreContainer__iAY3uE",
  "Qf": "loadMoreButton__fUYD0d",
  "zd": "loadMoreContent__3Umd6_",
};

module.exports = exports;
